import React from 'react';
import { Header, Card } from 'semantic-ui-react';

import Image from '../../../../../atoms/Image';
import { MenuConsumer } from '../../../FoodMenu.context';
import { ModifierSetsBasic } from '../modifiers';
import MenuUtil from '../../../utils/menu';
import { formatCurrency } from '../../../../../utils/currency';

const ItemVerticalCard = ({
  id,
  name,
  description,
  price,
  image,
  imageWidth = 500,
  onClick,
  className,
}) => {
  return (
    <MenuConsumer>
      {({ items, modifierSets }) => {
        const item = MenuUtil.getItemById(items, id);
        const { modifierSets: itemModifierSetIds } = item;
        const itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);

        return (
          <Card className={`fcfm-ivc ${className}`} onClick={onClick}>
            {image && <Image src={`${image}?width=${imageWidth}`} />}
            <Card.Content>
              <Card.Header style={{ display: 'flex' }}>
                <Header as="h5" style={{ flexGrow: 1, margin: 0 }}>
                  {name}
                </Header>
                {parseFloat(price) > 0 && (
                  <Header as="h5" style={{ margin: 0 }}>
                    {formatCurrency(price)}
                  </Header>
                )}
              </Card.Header>
              <Card.Description>{description}</Card.Description>
              <ModifierSetsBasic modifierSets={itemModifierSets} />
            </Card.Content>
          </Card>
        );
      }}
    </MenuConsumer>
  );
};

export default ItemVerticalCard;
